import { Box } from "@mui/material";
import { Typography } from "@powerdiary/components-library/lib";
import { useEffect, useState } from "react";

interface IProps {
    startTime: string;
    timerCompleted?: () => void;
}

export default function TelehealthTimer(props: Readonly<IProps>) {
    const { startTime, timerCompleted } = props;
    const [isTimerComplete, setIsTimerComplete] = useState(true);
    const [timespan, setTimespan] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        if (!startTime) return;

        const interval = setInterval(() => getTime(), 1000);

        const getTime = () => {
            const time = Date.parse(startTime) - Date.now();

            if (time >= 0) {
                setTimespan({
                    days: Math.floor(time / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((time / (1000 * 60 * 60)) % 24),
                    minutes: Math.floor((time / 1000 / 60) % 60),
                    seconds: Math.floor((time / 1000) % 60),
                });
                setIsTimerComplete(false);
            } else {
                setIsTimerComplete(true);
                if (timerCompleted) {
                    timerCompleted();
                }
                clearInterval(interval);
            }
        };

        return () => clearInterval(interval);
    }, [startTime, timerCompleted]);

    const formatNumber = (value: number) => {
        return value.toString().padStart(2, "0");
    };

    return (
        <>
            {!isTimerComplete && (
                <Box>
                    <Typography variant="paragraphExtraLargeRegular" data-test-id="text_starting_in_counter">
                        Starting in{" "}
                    </Typography>
                    <Typography variant="paragraphExtraLargeBold">
                        {timespan.days > 0 && formatNumber(timespan.days) + ":"}
                        {(timespan.days > 0 || timespan.hours > 0) && formatNumber(timespan.hours) + ":"}
                        {(timespan.days > 0 || timespan.hours > 0 || timespan.minutes > 0) &&
                            formatNumber(timespan.minutes) + ":"}
                        {formatNumber(timespan.seconds)}
                    </Typography>
                </Box>
            )}
        </>
    );
}
